var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41325 3.18016C4.64891 1.99944 6.29084 1.33837 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 7.63197 1.63173 7.3335 1.99992 7.3335C2.36811 7.3335 2.66659 7.63197 2.66659 8.00016C2.65667 10.5575 4.46343 12.762 6.97296 13.2544C9.48248 13.7468 11.9883 12.3886 12.9455 10.0171C13.9027 7.64561 13.0419 4.92847 10.8937 3.54086C8.74549 2.15325 5.9147 2.48581 4.14658 4.3335H5.74658C6.11477 4.3335 6.41325 4.63197 6.41325 5.00016C6.41325 5.36835 6.11477 5.66683 5.74658 5.66683H2.74659C2.3784 5.66683 2.07992 5.36835 2.07992 5.00016V2.00016C2.07992 1.63197 2.3784 1.3335 2.74659 1.3335C3.11477 1.3335 3.41325 1.63197 3.41325 2.00016V3.18016ZM7.33325 6.00016C7.33325 5.63197 7.63173 5.3335 7.99992 5.3335C8.36811 5.3335 8.66658 5.63197 8.66658 6.00016V7.3335H9.33325C9.70144 7.3335 9.99992 7.63197 9.99992 8.00016C9.99992 8.36835 9.70144 8.66683 9.33325 8.66683H7.99992C7.63173 8.66683 7.33325 8.36835 7.33325 8.00016V6.00016Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.fad44ee0aa6c29c76bf7d19ec6741498.svg";
export { ForwardRef as ReactComponent };